/* eslint-disable @typescript-eslint/no-explicit-any */
import apiService from './api'
import { sanitizeQueryParams } from '../utility/helpers/apiHelper'

interface GetBusinessesParams {
  page?: number
  pageSize?: number
  search?: string
  verificationStatus?: string
  city?: string
  category?: string
  orderBy?: string
  orderDirection?: 'ASC' | 'DESC'
  [key: string]: any
}

export interface FlagBusinessPayload {
  reason: string
  comment?: string
  severity?: string
}

export class BusinessService {
  async getBusinesses(query: GetBusinessesParams) {
    return apiService.get('/businesses', { params: sanitizeQueryParams(query) })
  }

  async getBusiness(id: string | number) {
    return apiService.get(`/businesses/${id}`)
  }

  async updateBusinessStatus(id: string | number, data: { status: string, verificationNotes?: string }) {
    return apiService.patch(`/businesses/${id}/status`, data)
  }

  async getDropdownCities() {
    return apiService.get('/businesses/city')
  }

  async getDropdownCategories() {
    return apiService.get('/businesses/category')
  }

  async flagBusiness(id: string | number, data: FlagBusinessPayload) {
    return apiService.post(`/businesses/${id}/flag`, data)
  }

  async getBusinessFlags(id: string | number) {
    return apiService.get(`/businesses/${id}/flags`)
  }

  async getBusinessComplianceHistory(id: string | number) {
    return apiService.get(`/businesses/${id}/compliance-history`)
  }

  async addBusinessInternalComment(id: string | number, comment: string) {
    return apiService.post(`/businesses/${id}/comments`, { comment })
  }
}

export const businessService = new BusinessService()
